module.exports = __webpack_public_path__ + "img/9791157062300.317f48c7.jpg";